module.exports = __webpack_public_path__ + "img/whisky.db3eb70d.jpg";